<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "PError",
  data: function () {
    return {
      is_open: false,
    }
  },
  computed: {
    ...mapState({
      is_auth: state => state.User.is_auth,
      popup_additional_data: state => state.Popups.popup_additional_data,
    }),
  },
  mounted() {
    setTimeout(() => {
      this.is_open = true;
    }, 100);
  },
  methods: {
    ...mapMutations(['SetPopupData',]),
    ...mapActions(['DeleteCall',]),

    hide() {
      this.is_open = false;
      setTimeout(() => {
        this.SetPopupData({popup_opened: false});
      }, 300);
    },
  },
  watch: {
    is_auth(newVal) {
      if (newVal === false) {
        this.hide();
      }
    },
  },
}
</script>

<template>
  <dialog class="popup" id="delete-confirm">
    <div class="popup-box" style="max-width: 464px;">
      <button type="button" class="popup-close" @click="hide"></button>
      <div class="popup-header">Error</div>
      <div class="popup-content center">
        <div class="popup-message">{{popup_additional_data.text}}</div>
        <button type="button" class="button" @click="hide">Ok</button>
      </div>
    </div>
  </dialog>
</template>

<style scoped>

</style>
